const config = {
  title: 'Layout Marketing Quill',

  defaults: {
    mode: 'container',

    containerWidth: 1360,

    disableGlobalFuseStyles: true,

    header: {
      display: true
    },
  
    footer: {
      display: true
    }
  }
};

export default config;